// @ts-check
import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import DropdownCustomFilterSearch from "./DropdownCustomFilterSearch.molecule"
import DropdownInput from "./DropdownInput.molecule"

/** @type {import("./DropdownWithTitleSubtitle.molecule")["default"]} */
const DropdownWithTitleSubtitle = forwardRef(
  (
    {
      placeholder,
      label,
      options,
      optionValue,
      titleKey = "title",
      subtitleKey = "subtitle",
      fullWidth = false,
      groupKey,
      inputProps,
      ...props
    },
    ref
  ) => {
    const valueTemplate = (option) => {
      const currentOption = options?.find(
        (o) => o?.[optionValue] === option?.[optionValue]
      )
      return (
        <div className="flex flex-column justify-content-between">
          <span
            className={`${fullWidth ? "w-full" : "max-w-10rem"} text-overflow-ellipsis white-space-nowrap overflow-hidden`}
          >
            {currentOption?.[titleKey] || placeholder || label}
          </span>
        </div>
      )
    }

    const itemTemplate = (option) => {
      const currentOption = options?.find(
        (o) => o?.[optionValue] === option?.[optionValue]
      )
      return (
        <div
          key={currentOption?.[subtitleKey]}
          className="flex flex-column justify-content-between category-item"
        >
          <span
            className={`${fullWidth ? "w-full" : "max-w-10rem"} text-overflow-ellipsis white-space-nowrap overflow-hidden`}
          >
            {currentOption?.[titleKey]}
          </span>
          <span
            className={`text-sm ${fullWidth ? "w-full" : "max-w-10rem"} white-space-normal`}
            style={{ color: "var(--secondary-color__dark)" }}
          >
            {currentOption?.[subtitleKey]}
          </span>
        </div>
      )
    }

    let optionsToUse = options
    if (options && groupKey) {
      const canGroupByKey = options?.findIndex((o) => o[groupKey]) !== -1
      if (canGroupByKey) {
        optionsToUse = options?.reduce((acc, value) => {
          const index = acc.findIndex((c) => c.label === value[groupKey])
          if (index === -1) {
            acc.push({
              label: value[groupKey],
              items: [
                {
                  ...value,
                },
              ],
            })
          } else {
            acc[index].items.push({
              ...value,
            })
          }
          return acc
        }, [])
      }
    }

    return (
      <DropdownInput
        ref={ref}
        label={label}
        placeholder={placeholder || label || undefined}
        options={optionsToUse}
        optionValue={optionValue}
        itemTemplate={itemTemplate}
        valueTemplate={(option) => valueTemplate(option)}
        filter
        // @ts-ignore
        filterTemplate={(
          /** @type {import("../molecules/DropdownCustomFilterSearch.molecule.types").ParentDropdownFilterProps} */
          props
        ) => {
          let inputPropsToUse

          if (inputProps) {
            if (typeof inputProps === "function") {
              inputPropsToUse = inputProps(props)
            } else {
              inputPropsToUse = inputProps
            }
          }
          return (
            <DropdownCustomFilterSearch
              props={props}
              inputProps={inputPropsToUse}
            />
          )
        }}
        emptyFilterMessage={"Misión fallida... no encontramos nada"}
        groupKey={groupKey}
        {...props}
      />
    )
  }
)

// @ts-ignore
DropdownWithTitleSubtitle.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  // @ts-ignore
  optionValue: PropTypes.string,
  // @ts-ignore
  optionLabel: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  titleKey: PropTypes.string,
  subtitleKey: PropTypes.string,
  fullWidth: PropTypes.bool,
  // @ts-ignore
  groupKey: PropTypes.string,
  inputProps: PropTypes.func,
  optionGroupTemplate: PropTypes.func,
}

export default DropdownWithTitleSubtitle
